export default __webpack_public_path__ + "static/media/Airbnb2.fa3e1ad7.png";